import { render, staticRenderFns } from "./Leaderboard_Entry.vue?vue&type=template&id=90c020a6&"
import script from "./Leaderboard_Entry.vue?vue&type=script&lang=js&"
export * from "./Leaderboard_Entry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports